import { h } from 'preact';

const BackIcon = props => {
  const { color, width = '32px', height = '32px', className = '', onClick } = props;

  return (
    <svg
      className={className}
      fill={color || '#000000'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28 25"
      width={width}
      height={height}
      onClick={onClick}
    >
      <path
        d="M 10 4.9296875 L 2.9296875 12 L 10 19.070312 L 11.5 17.570312 L 6.9296875 13 L 21 13 L 21 11 L 6.9296875 11 L 11.5 6.4296875 L 10 4.9296875 z"
        fill={color || '#000000'}
      />
    </svg>
  );
};

export default BackIcon;
